var _ = require('underscore');
var Section = require('submissions/pages/Section/Section');

require('./Profile.less');

var Banner = require('submissions/components/Banner/Banner');
var PasswordChange = require('submissions/components/PasswordChange/PasswordChange');

module.exports = Section.extend({

    el: '.Profile',

    events: {
        'click input': 'resetErrorState',
        'change input': 'resetErrorState',
        'focus  input': 'resetErrorState',
        'input input': 'resetErrorState',

        'click .Profile-saveButton': 'onSaveClick',
        'click .Profile-passwordButton': 'onPasswordClick'
    },

    //Base creates an instances for each one of found dom nodes (by selector) when parent view is rendered itself
    VIEWS_TO_REGISTER: {
        'Banner': {selector: '.Banner', viewConstructor: Banner}
    },


    initialize: function (options) {
        Section.prototype.initialize.call(this, options);
    },


    resetErrorState: function (e) {
        $(e.currentTarget)
            .closest('.Profile-inputLine')
            .removeClass('Profile-inputLine--error Profile-inputLine--error-with-input');
    },


    checkRequired: function (params) {
        var hasError = false;
        var self = this;

        //check form inputs
        this.$('.Profile-inputName').each(function (ind, item) {
            if (hasError) return;

            var $wrapper = $(item).closest('.Profile-inputLine');
            var $input = $('input', $wrapper).eq(0);

            if (!$input.length) return;

            var inputName = $input.attr('name');
            var inputType = $input.attr('type');

            var val = $.trim($input.val());

            if (!val) {
                params.focusOnError && $input.focus();
                $wrapper.addClass('Profile-inputLine--error-with-input');
                hasError = true;

                return;
            }
        });

        return !hasError;
    },


    getFormData: function () {
        var data = {
            'firstName':  this.$('input[name="firstName"]').val(),
            'lastName': this.$('input[name="lastName"]').val(),
            'company': this.$('input[name="company"]').val(),
            'phone': this.$('input[name="phone"]').val(),
            'email': this.$('input[name="email"]').val()
        };

        return data;
    },


    onSaveClick: function () {
        if (!this.checkRequired({focusOnError: true})) return;

        var $button = this.$('.Profile-saveButton');

        $button.addClass('Button--loading');

        this._xhr && this._xhr.abort();
        this._xhr = $.ajax(Urls['submissions:api:profile']('json'), {
            method: 'PUT',
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
            data: JSON.stringify(this.getFormData()),
            success: function (data) {
                $button.removeClass('Button--loading');
            }.bind(this),
            error: function (e, tp) {
                $button.removeClass('Button--loading');

                if (tp != 'abort') {
                    if (e.status == 400) { //bad request
                        alert('Error: ' + e.responseText);
                    } else {
                        alert('Error ' + e.status + ': ' + e.statusText);
                    }
                }

                console.log('error', arguments);
            }.bind(this)
        });
    },


    onPasswordClick: function () {
        this.passwordChange = this.passwordChange || new PasswordChange();

        this.passwordChange.show();
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/submissions/pages/Profile/Profile.js
// module id = 133
// module chunks = 0